<script>
import { deviceActivityMethods, deviceActivityComputed } from '@state/helpers'

export default {
  name: 'CActivityDetails',
  inheritAttrs: false,

  data: function() {
    return {
      selectedActivityEdit: 'disabled',
      selectedActivityName: null,
      activityPlanned: null,
      activityAvailability: null,
      activityWorking: null,
      activityQuality: null,
    }
  },

  computed: {
    ...deviceActivityComputed,
  },

  methods: {
    ...deviceActivityMethods,

    nameChanged: function(name) {
      this.selectedActivityName = name
      this.selectedActivityEdit = null
    },

    selectedActivityPlannedChanged(event) {
      this.activityPlanned = event.target.checked
      this.selectedActivityEdit = null
    },

    selectedActivityAvailabilityChanged(event) {
      this.activityAvailability = event.target.checked
      this.selectedActivityEdit = null
    },

    selectedActivityWorkingChanged(event) {
      this.activityWorking = event.target.checked
      this.selectedActivityEdit = null
    },

    selectedActivityQualityChanged(event) {
      this.activityQuality = event.target.checked
      this.selectedActivityEdit = null
    },

    ClickUpdateActivity: function(event) {
      this.selectedActivityEdit = 'disabled'
      let activityToUpdate = {
        name: this.selectedActivity.name,
        id: this.selectedActivity.id,
        available: this.selectedActivity.available,
        planned: this.selectedActivity.planned,
        working: this.selectedActivity.working,
        quality: this.selectedActivity.quality,
      }

      if (this.selectedActivityName) {
        activityToUpdate.name = this.selectedActivityName
      }
      if (this.activityPlanned != null) {
        activityToUpdate.planned = this.activityPlanned
      }
      if (this.activityAvailability != null) {
        activityToUpdate.available = this.activityAvailability
      }
      if (this.activityWorking != null) {
        activityToUpdate.working = this.activityWorking
      }
      if (this.activityQuality != null) {
        activityToUpdate.quality = this.activityQuality
      }

      this.updateActivity({ activity: activityToUpdate })
    },
  },
}
</script>

<template>
  <b-card>
    <div slot="header"> {{ selectedActivity.name }} </div>
    <b-row class="mt-3">
      <b-col sm="12">
        <b-form-group>
          <label for="name">Activity Name</label>
          <b-form-input
            id="name"
            type="text"
            :placeholder="selectedActivity.name"
            @change="nameChanged"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-form-group>
          <div class="clearfix mt-4"
            ><label>Activity Planned</label
            ><label class="float-right switch switch-label switch-pill switch-success">
              <input
                type="checkbox"
                true-value="true"
                false-value="false"
                class="switch-input form-check-input"
                :checked="selectedActivity.planned"
                @change="selectedActivityPlannedChanged"
              />
              <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
            </label>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-form-group>
          <div class="clearfix mt-4">
            <label>Activity Availability</label
            ><label class="float-right switch switch-label switch-pill switch-success">
              <input
                type="checkbox"
                true-value="value"
                false-value="uncheckedValue"
                class="switch-input form-check-input"
                :checked="selectedActivity.available"
                @change="selectedActivityAvailabilityChanged"
              />
              <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
            </label>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-form-group>
          <div class="clearfix mt-4"
            ><label>Activity Working</label
            ><label class="float-right switch switch-label switch-pill switch-success">
              <input
                type="checkbox"
                true-value="value"
                false-value="uncheckedValue"
                class="switch-input form-check-input"
                :checked="selectedActivity.working"
                @change="selectedActivityWorkingChanged"
              />
              <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
            </label>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-form-group>
          <div class="clearfix mt-4"
            ><label>Activity Quality</label
            ><label class="float-right switch switch-label switch-pill switch-success">
              <input
                type="checkbox"
                true-value="value"
                false-value="uncheckedValue"
                class="switch-input form-check-input"
                :checked="selectedActivity.quality"
                @change="selectedActivityQualityChanged"
              />
              <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
            </label>
          </div>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-button
          :class="{ disabled: selectedActivityEdit }"
          class="float-right"
          variant="success"
          @click="ClickUpdateActivity"
        >
          Update
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<style lang="scss">
@import '@design';

.detail {
  // opacity: 0.7;
  padding: 3em;
}
.detail:hover {
  // opacity: 1;
}
</style>
